import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token/token.service';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
	constructor(private readonly tokenService: TokenService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const headersRequest = request.clone({
			setHeaders: {
				'X-AUTH-TOKEN': this.tokenService.token,
				source: 'web',
				'If-Modified-Since': 'Wed, 16 Jul 1997 12:00:00 GMT',
				'Cache-Control': 'no-cache',
				Pragma: 'no-cache'
			}
		});

		return next.handle(headersRequest);
	}
}
